import {
  getAuth,
  sendSignInLinkToEmail as firebaseSendSignInLinkToEmail,
} from "firebase/auth";
import { MAGIC_LINK_EMAIL_KEY } from "modules/auth/constants";

const sendSignInLinkToEmail = async (
  email: string,
  redirectTo?: string,
  customDomainOverride?: string,
) => {
  const auth = getAuth();

  const root = customDomainOverride
    ? `https://${customDomainOverride}`
    : window.location.origin;

  await firebaseSendSignInLinkToEmail(auth, email, {
    url: `${root}/login/callback?redirectTo=${redirectTo ?? ""}`,
    handleCodeInApp: true,
  });

  localStorage.setItem(MAGIC_LINK_EMAIL_KEY, email);
};

export default sendSignInLinkToEmail;
